export function dict(obj) {
  const result = {
    _VALUES: {},
  }

  Object.entries(obj).forEach(([key, value]) => {
    result._VALUES[value] = key
    result[key] = value
  })

  return result
}
